<template>
    <div class="content-container">
      <div class="list-title">   
        <span class="list-title-text">服务列表</span>
        <div class="search-div">
          <el-switch v-if="level==1||level==2" v-model="isAll" @change="changeIsAll" active-value="1" inactive-value="0"></el-switch> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <el-input class="s-input" prefix-icon="el-icon-search" placeholder="请输入项目名称" @change="getList" v-model="pname" clearable></el-input>
        </div>
      </div>

      <!--列表-->
      <div class="list-result com-list">
          <div class="res-item" @click="dialogComponentShow = true"> 
            <div class="res-item-content add-demo">
              <div style="font-size: 16px;"><img style="width:70px" src="../../public/images/icon/demoadd.png" />
                <br/><br/>创建数据服务
                <br/>
                <br/><span v-if="level!=1&&level!=2" style="color: rgb(255 46 46);">非VIP用户只能创建十个项目</span>
              </div>
            </div>
          </div>
          
          <div class="res-item" v-for="item in list" :key="item.id">
              <div class="res-item-content" @mouseover="listMouseOver(item.id)" @mouseleave="listMouseLeave()">
                <!--头部文字信息-->
                <div class="source-header">
                  <el-tooltip class="item" effect="dark" :content="getProTypeName(item)" placement="top">
                    <img class="header-img" :src="$store.state.apiTemplateList[item.type + '_' + item.business].proTypeUrl">
                  </el-tooltip>
                  <div class="header-title">{{ item.name }}</div>
                  <div class="header-status" v-if="item.status==1">运行中</div>
                </div>

                <!--中部图片 + 报表-->
                <div class="res-item-background">
                  <!--API接口图片-->
                  <img class="api-img" :src="$store.state.apiTemplateList[item.type + '_' + item.business].url">
                  <!--业务类型图片-->
                  <div class="echarts-div" v-show="item.status==1" :id="'monthWorkOrder'+item.id"></div>
                </div>

                <!--底部按钮-->                
                <div class="source-foot">
                  <div class="source-foot-left">
                    <el-tooltip v-if="item.status==0" class="item" effect="dark" content="启动服务" placement="top">
                      <el-button @click="startProject(item)" type="danger" size="mini" icon="el-icon-caret-right" circle ></el-button>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" content="停止服务" placement="top">
                      <el-button @click="endProject(item)" size="mini" icon="el-icon-video-pause" circle ></el-button>
                    </el-tooltip>
                  </div>

                  <div class="source-foot-right">
                    <el-tooltip v-if="item.status==1" class="item" effect="dark" content="使用文档" placement="top">
                      <el-button @click="details(item)" size="mini" icon="el-icon-document" circle ></el-button>
                    </el-tooltip>
                    <el-tooltip v-if="item.status==0" class="item" effect="dark" content="服务配置" placement="top">
                      <el-button @click="edit(item)" size="mini" icon="el-icon-edit" circle ></el-button>
                    </el-tooltip>
                    <el-tooltip v-if="item.status==0" class="item" effect="dark" content="删除服务" placement="top">
                      <el-button @click="deleteProject(item)" size="mini" icon="el-icon-delete" circle ></el-button>
                    </el-tooltip>
                  </div>
                </div>
                <!--用户信息-->
                <div class="info-foot">
                  <div class="info-foot-left">{{item.createTimeStr}}</div>
                  <div class="info-foot-right">{{item.createBy}}</div>
                </div>
              </div>              
          </div>
      </div>

      <div style="padding: 10px 0;height: 40px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="curPage"
          :page-sizes="[10, 20, 30]"
          :page-size="curSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>

      <!--添加模板项目弹出框-->
      <AddProDialog
          v-if="dialogComponentShow"
          :dialogComponentShow="dialogComponentShow"
          @closeDialog="closeDialog"
          @okDialog="okDialog"
      ></AddProDialog>
      
    </div>    
</template>
<script>
  import * as echarts from 'echarts';
  import AddProDialog from '../components/AddProDialog.vue';
  export default {
    components: {
      AddProDialog
    },
    data() {
      return {
        pname: "",
        isAll: 0,
        curPage: 1, //应用列表当前页
        curSize: 10, //应用列表当前显示几个数据
        totalCount: 0,
        list: [], //查询列表
        modelList: this.$store.state.apiTemplateList,//服务模板列表
        caseList: [],//服务模板列表
        level: getCookieV('level1'),
        selectServer: '',
        selectBusiness: '',
        isActive: false,
        modelProject: {},
        dialogComponentShow: false
      };
    },
    methods: {
      nameBtn() {
        //打开“弹窗组件”
        this.dialogComponentShow = true
      },
      closeDialog() {
        //关闭“弹窗组件”
        this.dialogComponentShow = false
      },
      okDialog(){
        this.getList();
      },
      handleSizeChange(val) {
        this.curSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
         this.getList();
      },
      listMouseOver(id){
        this.listhover=id;
      },
      listMouseLeave(){
        this.listhover=0;
      },
      tempMouseOver(tempid){//模板选中鼠标移入事件
        
      },
      tempMouseLeave(){//模板选中鼠标移出事件
        
      },
      getProTypeName(item, attr){
        if(item.proType == "dataReporting"){
          return "数据上报服务";
        }else if(item.proType == "dataQuery"){
          return "数据查询服务";
        }
        return "";
      },
      changeIsAll(){
        let level = getCookieV('level1')
        if(level==1||level==2){
          setCookie("isAll", this.isAll, 1);
        }        
        this.getList();
      },
      getList() {//获取应用列表
        let _this = this;
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        this.axios({
          method: 'post',
          url: _this.api.listServerProject,
          params: {
            pageNum: _this.curPage,
            pageSize: _this.curSize,
            uid: uid,
            tk: token,
            name: _this.pname,
            isAll: _this.isAll
          },
        }).then(res=>{
          let data = res.data;
          if(data.code==200){
            for(let d of data.rows){
              d.createTimeStr = d.createTime.substring(0,10) + " " + d.createTime.substring(11,19);
            }
            _this.list = data.rows;
            _this.totalCount = data.total;
          }else if(data.code==-1){
              window.location.href=_this.api.loginHtmlUrl;
          }
        }).catch(function(e){
          console.log(e)
        })
      },
      edit(itme){
        let storeStr = itme.business + "Edit";
        this.$router.push({name: storeStr, query:{id: itme.id, type: itme.type, business: itme.business, proType: itme.proType}});
      },
      startProject(itme){
        let _this = this;
        if(itme.status != "0"){
          _this.$message({
            message: '该服务已经启动!',
            type: 'warning'
          });
          return false;
        }
        let loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        this.axios({
          method: 'post',
          url: _this.api.releaseServerProject,
          params: {
            id: itme.id,
            uid: uid,
            tk: token,
          },
        }).then(res=>{
          loading.close();
          let data = res.data;
          if(data.code==-1){
            window.location.href=_this.api.loginHtmlUrl;
          }else if(data.code==200){
            itme.status = 1;
            _this.$message({
              message: "启动成功！",
              type: 'success'
            });
            _this.initEcharts(itme);
          }else {
            _this.$message.error(data.msg);
          }
        }).catch(function(){
          loading.close();
          commonErrorTip(_this);
        })
      },
      endProject(itme){
        let _this = this;
        let loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: 'post',
          url: _this.api.stopServerProject,
          params: {
            id: itme.id,
            uid: uid,
            tk: token,
          },
        }).then(res=>{
          loading.close();
          let data = res.data;
          if(data.code==-1){
              window.location.href=_this.api.loginHtmlUrl;
          }else if(data.code==200){
            itme.status = 0;
            _this.$message({
              message: "服务停止成功！",
              type: 'success'
            });
          }else{
            _this.$message.error(data.msg);
          }
        }).catch(function(){
          loading.close();
          commonErrorTip(_this);
        })
      },
      details(itme){
        let storeStr = itme.business + "Details";
        this.$router.push({name: storeStr, query:{id: itme.id}});
      },
      deleteProject(itme){
        let _this = this;
        if(itme.status == 1){
          _this.$message({
            message: "服务正在运行，无法删除...",
            type: 'warning'
          });
          return false;
        }
        this.$confirm('删除后无法恢复，是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          del();
        });

        function del() {
          let loading = _this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          var uid = getCookieV('userid1');
	        var token = getCookieV('token1');
          _this.axios({
            method: "delete",
            url: _this.api.deleteServerProject,
            params: {
              id: itme.id,
              uid: uid,
              tk: token,
            },
          }).then((res) => {
            loading.close();
            let data = res.data;
            if (data.code == 200) {
              _this.$message({
                message: "服务删除成功！",
                type: "success",
              });
              _this.getList();
            } else if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
            } else {
              _this.$message.error(data.msg);
            }
          }).catch(function () {
            loading.close();
            commonErrorTip(_this);
          });
        }
      },
      initEcharts(itme) {
        let _this = this;
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: "get",
          url: _this.api.selectReportByIdServerProject+"/"+itme.id,
          params: {
            uid: uid,
            tk: token,
          },
        }).then((res) => {
          let data = res.data;
          if (data.code == 200) {
            createEcharts(itme, data.data);
          } else if (data.code == -1) {
            window.location.href = _this.api.loginHtmlUrl;
          } else {
            _this.$message.error(data.msg);
          }
        }).catch(function (e) {
          console.log(e);
        });


        
        function createEcharts(it, arr){
          let xaxisData = [];
          let updata = [];
          let seldata = [];
          let visdata = [];
          let userdata = [];
          if(arr != null && arr.length > 0){
            for(let d of arr){
              let t = new Date(d.stime*1000);
              let _h = t.getHours();
              let _m = t.getMinutes()>=10?t.getMinutes()+'':'0'+t.getMinutes();
              xaxisData.push(_h +":"+ _m);
              updata.push(d.uploadNum);
              seldata.push(d.selectNum);
              visdata.push(d.visitsNum);
              userdata.push(d.userNum);
            }
          }else{
            let t = new Date();
            let _h = t.getHours();
            let _m = t.getMinutes()>=10?t.getMinutes()+'':'0'+t.getMinutes();
            xaxisData.push(_h +":"+ _m);
            updata.push(0);
            seldata.push(0);
            visdata.push(0);
            userdata.push(0);
          }
          
          let legendData = [];// ['上报', '查询', '调用']
          let seriesData = [];
          if(it.proType == "dataReporting"){
            legendData.push('上报');
            seriesData.push({
                name: '上报',
                type: 'line',
                // stack: 'Total',
                data: updata
              });
          }else if(it.proType == "dataQuery"){
            legendData.push('查询');
            seriesData.push({
                name: '查询',
                type: 'line',
                // stack: 'Total',
                data: seldata
              });
          }else {
            legendData.push('调用');
            seriesData.push({
                name: '调用',
                type: 'line',
                // stack: 'Total',
                data: visdata
              });
          }
          
          legendData.push('用户数');
          seriesData.push({
              name: '用户数',
              type: 'line',
              // stack: 'Total',
              data: userdata
            });

          let myChart = echarts.init(document.getElementById('monthWorkOrder'+it.id))
          let options = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: legendData
            },
            grid: {
              left: '5%',
              right: '5%',
              bottom: '3%',
              // top: '30px',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: xaxisData
            },
            yAxis: {
              type: 'value',
              minInterval: 1
            },
            series: seriesData
          };
          myChart.setOption(options)
        }
        
      },
      selectTemp(obj){
        for(let l of this.caseList){
          l.active = false;
        }
        obj.active = true;
        this.modelProject = obj;
      }
    },
    created() {
      let level = getCookieV('level1')
      if(level==1||level==2){
        let isall = getCookieV('isAll');
        if(isall){
          this.isAll = isall;
        }
      }
      this.getList();
      this.$store.state.mainLeftMenu=2;
    },
    mounted() {
      let list = JSON.parse(JSON.stringify(this.$store.state.caseList));
      for(let l of list){
        l.active = false;
      }
      this.caseList = list;
    },
    watch: {
      list:function(){    //list为需要监听的data
        this.$nextTick(function() {
          for(let itme of this.list){
            if(itme.status == 1){
              this.initEcharts(itme);
            }
          }
        }); 
      }
    },
  }
  
</script>
<style lang="scss" scoped>
.search-div{
  position: absolute;
  font-size: 14px;
  right: 20px;
  top: 0px;
  font-size: 14px;
  line-height: 50px;
}


.s-input {
    width: 200px;
}

.el-pagination button, .el-pagination span:not([class*=suffix]){
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.el-pagination{
    white-space: nowrap;
    padding: 5px 5px;
    color: #303133;
    font-weight: 700;
}
.com-list {
    width: 100%;
    // height: calc(100% - 110px);
    margin-top: 10px;    
    overflow: overlay;
    box-sizing: border-box;
    align-content: start;
}
.list-result {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    // background: #fff;
}
.list-none{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: -30px;
    user-select: none;
}
.res-item{
    position: relative;
    box-sizing: border-box;
    margin:0 10px 20px 10px;
    overflow: visible;
    width: 300px;
}
.res-item-background{
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 40px;
    bottom: 70px;
    left: 0;
    right: 0;
}
.api-img{
  width: 100%;
  height: 100%; 
  border-radius: 5px;
  opacity: 0.4;
}
.business-img{
  position: absolute;
  padding: 10px;
  width: 40px;
  height: 40px;
  top: 0;
  right: 0;
  background: #f7f7f7;
  border-radius: 10px;
}
.echarts-div{
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.source-header{
  padding: 0 20px 0 40px;
  line-height: 40px;
  border-bottom: 1px solid #F1F1F1;
  .header-img{
    width: 30px;
    height: 30px;
    position: absolute;
    left: 5px;
    top: 5px;
  }
  .header-title{
    font-size: 16;
  }
  .header-status{
    position: absolute;
    right: 20px;
    top: 0;
    font-size: 20;
    font-weight: bold;
    color: rgb(64, 193, 113);
  }
}

.res-item-content{
    width: 300px;
    height: 330px;
    background: #FFFFFF;
    box-shadow: 0px 3px 3px 0px rgba(214, 214, 214, 0.49);
    border-radius: 10px;
    // background-image: url("../../public/images/icon/E.png");
    background-repeat: no-repeat;
    background-position: center;
    overflow: visible;
}

.add-demo{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  border: 2px dashed #9e9e9e;
  background: #fff;
  border-radius: 8px;
  color: #6b6f7a;
  text-align: center;
}


.res-item-content:hover{
    background-color: #DADDE3;
}

.source-foot{
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  padding: 0 20px;
  display: flow-root;
  border-top: 1px solid #F1F1F1;
  border-bottom: 1px solid #F1F1F1;
  line-height: 40px;
  .source-foot-left{
    display: inline-flex;
    line-height: 40px;
  }
  .source-foot-right{
    float: right;
  }
}

.info-foot{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 20px;
  line-height: 30px;
  display: flow-root;
  .info-foot-left{
    display: inline-flex;
    line-height: 30px;
  }
  .info-foot-right{
    float: right;
  }
}

.temp-pro{
  height: 150px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  // overflow: auto;
}

.temp-item {
  width: 153px;
  height: 108px;
  background: #323232;
  position: relative;
  margin: 20px 16px;
  border-radius: 4px;
  padding: 2px;
}

.temp-item.active {
    border: 2px solid #fc8e36;
    padding: 0px;
}

.temp-item-content{
  width: 100%;
  height: 80%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.temp-item-content img{
  position: absolute;
  width: 100%;
  height: 80%;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.temp-item-bottom{
  text-align: center;
  position: absolute;
  /* background: #7e7e7e45; */
  color: #ddd;
  bottom: 0;
  width: 100%;
  height: 20%;
}

.model-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    // background: #fff;
}
.mode-item{
    position: relative;
    box-sizing: border-box;
    margin:0 10px 20px 10px;
    overflow: visible;
    width: 250px;
}
.mode-item-background{
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 19px;
    background-color: #fff;
}
.mode-item-content{
    width: 250px;
    height: 150px;
    background: #FFFFFF;
    box-shadow: 0px 3px 3px 0px rgba(214, 214, 214, 0.49);
    border-radius: 10px;
    background-repeat: no-repeat;
    background-position: center;
    overflow: visible;
    border: 2px solid #fff;
}
.mode-item-content:hover{
    border: 2px solid #ff7628;
}
.mode-item-pname{
  text-align: center;
  margin-top: 10px;
  overflow-wrap: break-word;
}

</style>